// Constants
import { RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
import { HeaderOnboardingVariantsType } from '../../../designSystem/reloaded/commons/components/header-onboarding';
// eslint-disable-next-line @kubit-ui-web/no-index-import/no-index-import
import { DeviceBreakpointsType } from '../../../types';
import { getButtonChildrenConfiguration, getButtonIconConfiguration, } from './utils/header-onboarding.configuration.util';
export const getIllustrationConfiguration = ({ illustration, device, }) => ({
    fileExtension: 'svg',
    height: [DeviceBreakpointsType.MOBILE].includes(device) ? '32px' : '40px',
    illustration: 'logo_brand_adaptive-converted',
    ...illustration,
});
export const getButtonConfiguration = ({ button, device, variant, }) => ({
    size: [DeviceBreakpointsType.MOBILE].includes(device)
        ? RELOADED_VARIANTS.ButtonSizeType.ICON_SMALL
        : RELOADED_VARIANTS.ButtonSizeType.ICON_MEDIUM,
    type: variant === HeaderOnboardingVariantsType.DEFAULT
        ? RELOADED_VARIANTS.ButtonVariantType.SECONDARY_GHOST
        : RELOADED_VARIANTS.ButtonVariantType.SECONDARY,
    ...button,
    iconConfiguration: {
        ...getButtonIconConfiguration({ device, variant }).iconConfiguration,
        ...button?.iconConfiguration,
    },
    iconPosition: button?.iconPosition ?? getButtonIconConfiguration({ device, variant }).iconPosition,
    children: getButtonChildrenConfiguration({ device, button, variant }),
});
//# sourceMappingURL=header-onboarding.configuration.js.map